import { useMemo } from "react";
import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";

interface AnnuallyPerformancePotentialProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
  chartYears: string[];
}

const AnnuallyPerformancePotential = ({
  croppingSuitabilityReports,
  chartYears,
}: AnnuallyPerformancePotentialProps) => {
  const chartData = useMemo(
    () =>
      chartYears?.map((year, index) => ({
        name: year,
        value:
          croppingSuitabilityReports[0]?.annuallyPerformancePotential[index]
            ?.value,
      })),
    [chartYears, croppingSuitabilityReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={4}>
      <div className="w-full flex flex-col gap-10">
        <Title>پتانسیل عملکرد 30 سال گذشته</Title>
        <div className="w-full flex flex-col justify-center items-center gap-3 my-8">
          <ColumnChart
            data={chartData}
            height={350}
            title={"پتانسیل عملکرد"}
            titleFontSize="12px"
            color="#4682B4"
            labelsFontSize="10px"
            yAxisTitle={"پتانسیل عملکرد(تن در هکتار)"}
          />
          <Title>مقدار پتانسیل عملکرد برآورد شده در 30 سال گذشته</Title>
        </div>
      </div>

      <NoteBox>
        با توجه به شرایط اقلیمی منطقه، پتانسیل عملکرد محصولات برآورد شده است.
        پتانسیل عملکرد به معنای بالاترین میزان عملکردی است که با مدیریت بهینه
        تمامی عوامل موثر بر عملکرد (مانند آبیاری، تغذیه گیاهی و...) می‌توان به
        آن دست یافت. بنابراین، در نظر داشته باشید که مقدار واقعی عملکرد با توجه
        به شرایط خاک و شرایط مدیریتی کمتر از این مقدار خواهد بود و با بهبود
        مدیریت مزرعه میتوان به پتانسیل عملکرد نزدیک شد.
      </NoteBox>
    </ReportTemplate>
  );
};

export default AnnuallyPerformancePotential;
